import { cn } from "@/lib/utils";
import { Zap } from "lucide-react";

export function LightningActivityIndex({ value, size = "default", showLabel = true, className }) {
  const segments = Array.from({ length: 10 }, (_, i) => i + 1);
  
  // Determine color based on value
  const getSegmentColor = (segmentIndex, currentValue) => {
    if (segmentIndex > currentValue) return "bg-[#2e2e2e]";
    
    if (currentValue <= 3) return "bg-[#A8CFB6]"; // Weak - green
    if (currentValue <= 5) return "bg-[#E9D85A]"; // Moderate - yellow
    if (currentValue <= 7) return "bg-[#F89C27]"; // Strong - orange
    if (currentValue <= 9) return "bg-[#F33D14]"; // Severe - red
    return "bg-[#B45AA9]"; // Violent - purple
  };
  
  const getGlowColor = (currentValue) => {
    if (currentValue <= 3) return "rgba(168, 207, 182, 0.5)";
    if (currentValue <= 5) return "rgba(233, 216, 90, 0.5)";
    if (currentValue <= 7) return "rgba(248, 156, 39, 0.5)";
    if (currentValue <= 9) return "rgba(243, 61, 20, 0.5)";
    return "rgba(180, 90, 169, 0.5)";
  };

  return (
    <div className={cn("space-y-2", className)} data-testid="lightning-activity-index">
      {showLabel && (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Zap className="w-4 h-4 text-[#FBBF24]" />
            <span className="font-heading text-xs uppercase tracking-widest text-[#9CA3AF]">
              Lightning Activity Index
            </span>
          </div>
          <span className="font-mono text-sm font-semibold text-[#F9FAFB]">
            {value}/10
          </span>
        </div>
      )}
      
      <div className={cn(
        "flex gap-1 w-full",
        size === "small" ? "h-1.5" : "h-2.5"
      )}>
        {segments.map((segment) => (
          <div
            key={segment}
            className={cn(
              "flex-1 transition-all duration-300",
              getSegmentColor(segment, value)
            )}
            style={{
              boxShadow: segment <= value ? `0 0 8px ${getGlowColor(value)}` : "none"
            }}
            data-testid={`lightning-segment-${segment}`}
          />
        ))}
      </div>
      
      {size !== "small" && (
        <div className="flex justify-between text-[9px] font-mono text-[#6B7280] uppercase tracking-wider">
          <span>Low</span>
          <span>Moderate</span>
          <span>Extreme</span>
        </div>
      )}
    </div>
  );
}
